import React from 'react';

import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const Constructor = ({ listConstructor }) => {
    return (
        <div className="constructor-pochtabank">
            <FullWrapper>
                <div className="constructor-pochtabank__Title">
                    Контентная система управления и&nbsp;конструктор
                </div>

                <div className="constructor-pochtabank__Inner">
                    <div className="constructor-pochtabank__Left">
                        В&nbsp;банке разветвленная оргструктура с&nbsp;десятком ответственных лиц,
                        которые модерируют свой раздел сайта. Вдобавок к&nbsp;этому накладываются
                        сложные бизнес-процессы согласования контентных изменений. Поэтому
                        в&nbsp;техзадании заказчика изначально были достаточно широкие требования
                        к&nbsp;системе управления и&nbsp;хранения контента. Фактически требовался
                        версионированный конструктор, чтобы вносить изменения и&nbsp;делать деплой
                        одной кнопкой.
                    </div>
                    <div className="constructor-pochtabank__Right">
                        В&nbsp;техзадании заказчика изначально были достаточно широкие требования
                        к&nbsp;системе управления и&nbsp;хранения контента.
                    </div>
                </div>

                <div className="constructor-pochtabank__Container">
                    <div className="constructor-pochtabank__Subtitle">Основные требования</div>
                    <div className="constructor-pochtabank__List">
                        {listConstructor.map((item, index) => (
                            <div className="constructor-pochtabank__Item" key={index}>
                                <div className="constructor-pochtabank__Number">{item.number}</div>
                                <div
                                    className="constructor-pochtabank__Text"
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="constructor-pochtabank__Block">
                    Для такого конструктора решили создать отдельную тестовую площадку, где все
                    изменения контента можно просмотреть и&nbsp;перенести по&nbsp;согласованию
                    на&nbsp;прод без участия разработчиков. Все исправления вносятся сразу
                    в&nbsp;базу, поэтому отпала необходимость делать отдельный инстанс
                    с&nbsp;переносом через git.
                </div>

                <div className="constructor-pochtabank__Image">
                    <img src="/images/pic/new-pochtabank/constructor.jpg" alt="constructor" />
                </div>

                <div className="constructor-pochtabank__Inner">
                    <div className="constructor-pochtabank__Left">
                        <div>
                            Так как основная разработка велась на&nbsp;React, то&nbsp;часть
                            требований по&nbsp;конструктору сразу закрыл open source инструмент
                            tina.io. Он&nbsp;позволил на&nbsp;современном и&nbsp;удобном стеке
                            реализовать визуальное редактирование блоков, их&nbsp;состав, структуру
                            и&nbsp;порядок.
                        </div>
                        <div>
                            Библиотеку блоков закрыл функционал Storybook, который обеспечил
                            повышенную переиспользуемость и&nbsp;документированность компонентов.
                            Структуру страниц, блоков построили на&nbsp;базе инфоблоков.
                            Версионирование реализовали с&nbsp;помощью включенного функционала
                            документооборота.
                        </div>
                        <div>
                            Нативный функционал Битрикс легко интегрировался с&nbsp;инфоблоками
                            и&nbsp;отлично закрыл этот кейс.
                        </div>
                    </div>
                    <div className="constructor-pochtabank__Right">
                        <div className="constructor-pochtabank__Description">
                            <div className="constructor-pochtabank__Top">
                                Визуальный редактор контента
                            </div>
                            <div className="constructor-pochtabank__Bottom">
                                <img
                                    src="/images/pic/new-pochtabank/tina.jpg"
                                    alt="github"
                                    className="constructor-pochtabank__Icon"
                                />
                                <div>Tina.io</div>
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Constructor;
